<div class="app-container">
    <ng-container *ngIf="!isBlocked; else blockedTemplate">
        <app-community-sidenav></app-community-sidenav>
        <div class="content" [ngStyle]="{'background-color': settingsData?.space_main_bg_color}">
            <router-outlet></router-outlet>
        </div>
    </ng-container>
    <ng-template #blockedTemplate>
        <div class="w-100 d-flex flex-column bg-color fs-20">
            <div>{{ isLoading ? 'Connecting to community...' : 'You have been blocked'}}</div>
            <div *ngIf="!isLoading">
                <button class="btn flat-primary-button tertiary-bg-button mt-10" (click)="goToHome()">Go to Home</button>
            </div>
        </div>
    </ng-template>
</div>